export default "__VITE_ASSET__5d9XbdVB__"